import React from 'react';
import FormEmpresa from '../../../components/login/form-empresa';

export default function CadastroEmpresa(){
    return (
        <FormEmpresa />
    )

}